<template>
  <v-sheet v-if="userInfo" color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <div class="profile-content">
        <h1>My Profile</h1>
        <ContactInfo />
        <change-password />
      <v-card class="user-profile-card">
        <v-row>
          <v-col>
            <h3 class="mb-3">Communication Preferences</h3>
            <p class="ml-3">
              From time-to-time you will be included in ASCA-related business, such
              as membership renewals, dog or puppy updates or other registration
              matters. How would you like to be notified about updates, changes and
              interactions related to your ASCA account?
            </p>
          </v-col>
        </v-row>
        <v-row class="ml-3">
          <v-spacer />
          <v-col>
            <v-checkbox
              v-model="communicationPreferences.email"
              :disabled="!userInfo.verifiedEmail"
              label="Email"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="communicationPreferences.sms"
              :disabled="!userInfo.verifiedSMS"
              label="SMS"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3 class="mb-3">Green ASCA: Documents Printing Preferences</h3>
            <p class="ml-3">
              In order to reduce paper usage, manual processing efforts and postage costs, we're gradually introducing the alternative "green" variants of our services.<br/>
              If you'd like to support our initiative, you can change your preferences in this section. <b>The changes need to be saved to take effect.</b>
            </p>
          </v-col>
        </v-row>
        <v-row class="ml-3">
          <v-col>
            <v-checkbox
              :color="communicationPreferences.digitalOnlyTitleCert  ? 'green' : 'red'"
              v-model="communicationPreferences.digitalOnlyTitleCert"
            >
              <template v-slot:label>
                <v-icon 
                  :color="communicationPreferences.digitalOnlyTitleCert ? 'green' : 'red'"> 
                  mdi-leaf 
                </v-icon>
                <span :color="communicationPreferences.digitalOnlyTitleCert ? 'green' : 'red'">Title certificates: digital only</span>
                <v-tooltip slot="append" dark top>
                  <template v-slot:activator="{on, attrs}">
                    <font-awesome-icon
                      icon="info-circle"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    />&nbsp;
                  </template>
                  <span>
                    &nbsp;Opting-out from printed versions means that your title certificates won't be printed and mailed anymore. The digital title certificate can always be downloaded in your dog's profile.
                  </span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </v-col>
          <v-spacer />
        </v-row>
        <v-alert
          class="mb-2 mt-1"
          v-if="errorMessage"
          :type="'error'">
          {{ errorMessage }}
        </v-alert>
        <v-overlay :value="showLoader">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="70"
            :width="7"
          ></v-progress-circular>
        </v-overlay>
        <v-row class="ma-0">
          <v-spacer />
          <v-btn 
                dark
                large
                color="primary"
                width="125px"
                @click="savePreference"
              >Save</v-btn>
        </v-row>
      </v-card>
      <div v-show="false" id="print-card">
        <div id="membership-card">
          <p>ID: {{ userInfo.memberId }}</p>
          <p>
            Expiration:
            <localized-date :date="userInfo.membershipExpiryDate" />
          </p>
          <p>Name: {{ userInfo.firstName }} {{ userInfo.lastName }}</p>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import ContactInfo from "@/components/Portal/Profile/ContactInfo.vue";
import ChangePassword from "@/components/Portal/Profile/ChangePassword.vue";
import personService from "@/services/portal/personService";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "UserProfile",
  components: {
    ContactInfo,
    ChangePassword,
  },
  data: function() {
    return {
      showLoader: false,
      errorMessage: "",
      communicationPreferences: {
        email: null as any,
        sms: null as any,
        digitalOnlyTitleCert: false as boolean,
      },
    };
  },
  created: function () {
    this.loadCommunicationPreferences();
  },  
  watch: {
    userInfo: function(newValue, oldValue){
      if (newValue === oldValue) return;

      this.loadCommunicationPreferences();
    },
  },
  computed: {
    userInfo(): UserInfo | null {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    loadCommunicationPreferences() {
      if (!this.userInfo) return;

      personService
        .getCommunicationPreferences()
        .then((res) => {
          if(res.found) {
            this.$data.communicationPreferences = res.data;
          } else {
            this.$data.errorMessage = "Couldn't load the person communication preferences.";
          }
        })
        .catch(this.$handleError);
    },
    async print() {
      await this.$htmlToPaper("print-card");
    },
    requestCard() {

    },
    renewMembership() {

    },
    savePreference() {
      if (!this.userInfo) return;

      if(!this.communicationPreferences.email && !this.communicationPreferences.sms)
      {
        this.errorMessage = "You need to choose at least one communication channel.";
      } else {
        this.errorMessage = "";
        this.showLoader = true;
        personService
          .changeCommunicationPreferences(
            this.communicationPreferences.email,
            this.communicationPreferences.sms,
            this.communicationPreferences.digitalOnlyTitleCert,
          )
          .then((res) => {
            if (res.success) {
            } else {
              this.errorMessage = res.errorMessage;
            }
          })
          .finally(() => {
            this.showLoader = false;
          });
      }
    },
  },
});
</script>
